export { BlogCard } from './ui/card';
export { BlogCategoryBox } from './ui/category-box';
export { BlogCTABar } from './ui/cta-bar';
export {
    BlogDetail,
    BlogDetailWrapper,
    BlogDetailTitle,
    BlogDetailTags,
    BlogDetailDescription,
    BlogDetailContent,
    BlogDetailMedia,
} from './ui/detail';
// BlogHeroBanner is a Server Component (sharp/blur64) — import from
// `@/widgets/blog/ui/hero-banner`, never from this barrel (client prefab pulls it).
export { BlogNewsletterBox } from './ui/newsletter-box';

// Namespace-style access for prefab registry (`BlogDetail.Wrapper`, …)
export * as BlogDetailParts from './ui/detail';
